import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  loading: false,
  data: [],
  history: [],
})

const { Types, Creators } = createActions({
  syncPendingCashOuts: null,
  unSyncPendingCashOuts: null,

  setPendingCashOuts: ['data'],

  getHistoryCashOuts: ['from', 'to'],
  setHistoryCashOuts: ['data'],
  setCashOutsLoading: ['val'],

  confirmCashOut: ['requestId', 'callback'],
  cancelCashOut: ['requestId', 'reason', 'callback'],
})

export const setHistoryCashOutsReducer = (state, { data }) => state
  .set('history', data)
  .set('loading', false)

export const setPendingCashOutsReducer = (state, { data }) => state
  .set('data', data)
  .set('loading', false)

export const setCashOutsLoadingReducer = (state, { val }) => state.set('loading', val)

export const syncPendingCashOutsReducer = state => state.set('loading', true)

export const getHistoryCashOutsReducer = state => state.set('loading', true)

export const cashOutReducer = createReducer(INITIAL_STATE, {
  [Types.SET_HISTORY_CASH_OUTS]: setHistoryCashOutsReducer,
  [Types.SET_CASH_OUTS_LOADING]: setCashOutsLoadingReducer,
  [Types.SYNC_PENDING_CASH_OUTS]: syncPendingCashOutsReducer,
  [Types.SET_PENDING_CASH_OUTS]: setPendingCashOutsReducer,
  [Types.GET_HISTORY_CASH_OUTS]: getHistoryCashOutsReducer,
})

export const CashOutTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/cashOutReducer.js